import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      acceptServiceTerms: 'By clicking on the "continue" button you confirm that you have read and accepted the <1>Terms and Conditions of the service</1>.',
      acceptServiceTermsLink: 'https://zappyrent.zendesk.com/hc/en-us/articles/4407475132049-Terms-and-Conditions',
      acceptServiceTermsTitle: 'Terms and Conditions of Zappyrent service',
      required: 'Field required',
      signIn: 'Sign In',
      signUp: 'Sign Up',
      recoverPass: 'Don\'t remember password?',
      notSignUp: 'Not Signed up? <1>Sign Up here</1>',
      alreadySignUp: 'Already signed up? <1>Sign in here</1>',
      anotherAccount: 'Isn\'t your account? <1>Use another account</1>',
      loginSuccess: 'Login success, you\'ll be redirected to the page, just a second',
      registerSuccess: 'Sign up successed, you\'ll be redirected to the page, just a second',
      continue: 'Continue',
      alreadyRegistered: 'Already signed up',
      errorSignUp: 'Oh no there was an error, please retry later or contact support',
      noAccount: 'Account not found',
      accountSocial: 'Login with facebook or google account',
      unauthorized: 'Wrong password',
      errorSocial: 'There was an error with social login',
      landlord: 'Landlord',
      tenant: 'Tenant',
      passwordMax: 'Password must be at least 8 characters',
      phoneNumber: 'Phone number',
      insertPhone: 'Insert Phone Number',
      insertPhoneDesc: 'Enter the verification code that we sent to your number. If you don\'t receive the message or call within 5 minutes, try again',
      sendCode: 'Send code',
      verifyNumber: 'Verify number',
      verifyCode: 'Verify code',
      name: 'Name',
      surname: 'Surname',
      email: 'Email',
      password: 'Password',
      sendCodeSuccess: 'Code sent successfully',
      sendCodeFailed: 'Error sending verification code',
      forgotPasswordLink: 'Forgot Password',
      forgotPasswordSuccess: 'We have sent you an email with your new password and a link to create a new one',
      forgotPasswordFail: 'There was an error with your login, please retry later',
      validPhoneNumber: 'Enter a valid phone number',
    }
  },
  it: {
    translation: {
      acceptServiceTerms: 'Cliccando sul tasto "continua" confermi di aver preso visione e accettato i <1>Termini e le Condizioni del servizio</1>.',
      acceptServiceTermsLink: 'https://zappyrent.zendesk.com/hc/it/articles/4407475132049-Termini-e-Condizioni-del-Servizio',
      acceptServiceTermsTitle: 'Termini e Condizioni del servizio Zappyrent',
      required: 'Campo obbligatorio',
      signIn: 'Accedi',
      signUp: 'Registrati',
      recoverPass: 'Password dimenticata?',
      notSignUp: 'Non sei registrato? <1>Registrati qui</1>',
      alreadySignUp: 'Sei già registrato? <1>Accedi da qui</1>',
      anotherAccount: 'Non è il tuo account? <1>Usa un altro account</1>',
      loginSuccess: 'Login effettuato con successo, verrai renderizzato alla pagina, dammi qualche secondo',
      registerSuccess: 'Registrazione effettuata con successo, verrai renderizzato alla pagina, dammi qualche secondo',
      continue: 'Continua',
      alreadyRegistered: 'Account già registrato',
      errorSignUp: 'Oh no c\'è stato un errore, riprova tra poco o contatta il supporto',
      noAccount: 'Account non trovato',
      accountSocial: 'Accedi con facebook o google',
      unauthorized: 'Password errata',
      errorSocial: 'C\'è stato un errore',
      landlord: 'Proprietario',
      tenant: 'Inquilino',
      passwordMax: 'La password deve essere almeno di 8 caratteri',
      phoneNumber: 'Numero di telefono',
      insertPhone: 'Inserisci il tuo numero di telefono',
      insertPhoneDesc: 'Inserisci il codice di verifica che abbiamo inviato sul tuo numero. Se non ricevi il messaggio o la chiamata entro 5 minuti, riprova',
      sendCode: 'Invia codice',
      verifyNumber: 'Verifica numero',
      verifyCode: 'Verifica codice',
      name: 'Nome',
      surname: 'Cognome',
      email: 'Email',
      password: 'Password',
      sendCodeSuccess: 'Codice inviato con successo',
      sendCodeFailed: 'Errore nell\'invio del codice di verifica',
      forgotPasswordLink: 'Password dimenticata',
      forgotPasswordSuccess: 'Ti abbiamo mandato un email con la tua nuova password ed un link per crearne una nuova',
      forgotPasswordFail: 'C\'è stato un problema, riprova tra poco o contatta il supporto',
      validPhoneNumber: 'Inserisci un numero di telefono valido',
    }
  }
}
// not like to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    fallbackLng: 'en',
    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });

export default i18n;